export const DIAGRAM_TOOLBAR_SAVE_EVENT = 'diagram-toolbar-save-request';

export const DIAGRAM_TYPES = {
    REGULATORY: 'regulatory',
    POLICY: 'policy',
};
